import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Territory from './icon-territory.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Territory {...validProps} />;
}
SvgComponent.iconName = 'territory';

/**
 * @deprecated This is a legacy icon
 */
export const TerritoryIcon = svgIconWrapper(SvgComponent);
